<template>
  <div>
    <div class="strip-heading">
      <div class="strip-heading-title">Clients</div>
      <p>
        We provide cyber security, cloud and development services for organisations country-wide, both large and small.
        We'd love to help you too, just give us a call when you're ready to get started.
      </p>
    </div>
    <div class="strip">
      <img :src="'/clients/' + logo.img" :alt="logo.name" :key="logo.name" v-for="logo in logos" />
    </div>
  </div>
</template>

<script>
export default {
  name: "clients",
  data() {
    return {
      logos: [
        { img: "northern.jpg", name: "Northern Media" },
        { img: "enable.jpg", name: "Enable Holidays" },
        { img: "spj.jpg", name: "SPJ Marketing" },
        { img: "pemberley.jpg", name: "Pemberley Wills and Estate Planning" },
        { img: "transmit.jpg", name: "Transmit Creative" },
        { img: "clearview.jpg", name: "Clearview Secondary Glazing" },
        { img: "result.jpg", name: "Result Consultancy" },
        { img: "jeremycooper.jpg", name: "Jeremy Cooper" },
        { img: "q2.jpg", name: "Q2 Creative" }
      ]
    }
  }
}
</script>
